import {
  Backdrop,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import useStyles from "./useStyle"
import {
  getAllGlobalNotification,
  getAllNotificationTypes,
  setRequestTypes,
} from "../../../redux/actions/GlobalNotification"
import EditIcon from "@mui/icons-material/Edit"
import { useDispatch, useSelector } from "react-redux"
import { NavLink } from "react-router-dom"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import { DeleteNotification } from "../Modals/DeleteNotification"
import { getUserRoles } from "../../../utils/validateToken"

export const NotificationBox = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(null)
  const [notifications, setnotifications] = useState([])
  const dispatch = useDispatch()
  const [openModal, setopenModal] = useState(false)
  const [notificationId, setNotificationId] = useState(null)
  const { types } = useSelector((state) => state.globalNotification)
  const user = useSelector((state) => state.user)

  const getAllNotification = async () => {
    setLoading(true)
    const response = await dispatch(
      getAllGlobalNotification(null, ["ME", "ME"]),
    )
    if (Array.isArray(response)) {
      setnotifications(response)
    }
  }

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    }
    return formattedDate
  }

  const formatTimeArg = (date) => {
    if (date) {
      const options = {
        timeZone: "America/Argentina/Buenos_Aires",
        hour: "2-digit",
        minute: "2-digit",
      }
      return new Date(date).toLocaleTimeString("es-AR", options)
    }
    return ""
  }
  const handleOpen = (notificationId) => {
    setopenModal(true)
    setNotificationId(notificationId)
  }

  const handleClose = () => {
    setopenModal(false)
  }

  const formatType = (typeCode) => {
    return (
      types.find((type) => type.notificationTypeCode === typeCode)
        ?.notificationTypeDesc || typeCode
    )
  }

  const isRoleOnlyRead = () => {
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0) {
      return appRoles.includes("CGI.GlobalNotificationReader")
    }
    return false
  }
  const isTypeNotEnabled = (type) => {
    if (
      getUserRoles(user.eAuthToken).includes(
        "CGI.GlobalNotificationInfoOperator",
      )
    ) {
      return type === "ADVERTISEMENT" || type === "INFORMATION"
    }
    return true
  }

  useEffect(async () => {
    setLoading(true)
    await dispatch(getAllNotificationTypes())
    await getAllNotification()
    setLoading(false)

    return () => {
      dispatch(setRequestTypes())
    }
  }, [])

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {notifications &&
        notifications.map((item) => (
          <Grid container className={classes.boxDetails} key={item.id}>
            <Grid item xs={12} className={classes.titleContainer}>
              <div className={classes.boxtitle}>
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    color: "#4B4952",
                    paddingLeft: 10,
                  }}
                >
                  {item.notificationTitle || "Notificación sin título"}
                </Typography>
              </div>
              {item.isActive &&
                !isRoleOnlyRead() &&
                isTypeNotEnabled(item.notificationTypeCode) && (
                  <div className={classes.iconContainer}>
                    <Tooltip title="Editar">
                      <NavLink
                        to={`/globalNotification/edit/${item.notificationId}`}
                      >
                        <EditIcon className={classes.iconStyle} />
                      </NavLink>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                      <DeleteForeverIcon
                        className={classes.iconStyle}
                        style={{ marginLeft: "25%" }}
                        onClick={() => handleOpen(item.notificationId)}
                      />
                    </Tooltip>
                    <DeleteNotification
                      openModal={openModal}
                      handleClose={handleClose}
                      item={notificationId}
                    />
                  </div>
                )}
            </Grid>
            <Grid container style={{ padding: 10 }}>
              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Texto:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {item.notificationText || "Notificación sin texto"}
                </Typography>
              </Grid>

              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Fecha de inicio:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {formatDate(item.validityStartDate)
                    ? formatDate(item.validityStartDate)
                    : "Fecha no definida"}{" "}
                  {formatTimeArg(item.validityStartDate)}
                </Typography>
              </Grid>

              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Fecha de finalización:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {" "}
                  {formatDate(item.validityFinishDate)
                    ? formatDate(item.validityFinishDate)
                    : "Fecha no definida"}{" "}
                  {formatTimeArg(item.validityFinishDate)}
                </Typography>
              </Grid>

              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Tipo:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {formatType(item.notificationTypeCode)}
                </Typography>
              </Grid>

              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Aplicación:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {item.applicationName}
                </Typography>
              </Grid>

              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Canal de comunicación:
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {item.communicationChannels &&
                  item.communicationChannels.length > 0 ? (
                    <div>
                      Canal 1:{" "}
                      {item.communicationChannels[0].communicationChannelDesc}
                      <br />
                      {item.communicationChannels.length > 1 && (
                        <div>
                          Canal 2:{" "}
                          {
                            item.communicationChannels[1]
                              .communicationChannelDesc
                          }
                        </div>
                      )}
                    </div>
                  ) : (
                    "No hay canales de comunicación"
                  )}
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,

                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  Está activo:
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {item.isActive ? "Si" : "No"}
                </Typography>
              </Grid>
              {item.relatedNotificationId && (
                <>
                  <Grid item xs={4} style={{ paddingTop: 3 }}>
                    <Typography
                      style={{
                        fontSize: 14,

                        fontWeight: "bold",
                        color: "#485450",
                      }}
                    >
                      Notificación asociada:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} style={{ paddingTop: 3 }}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "#6e7a76",
                      }}
                    >
                      {item.relatedNotificationTitle}
                    </Typography>
                  </Grid>
                </>
              )}
              {item?.destinationExclusions?.suborganizationGroups &&
                item?.destinationExclusions?.suborganizationGroups.length >
                  0 && (
                  <>
                    <Grid item xs={12} style={{ paddingTop: 3 }}>
                      <Typography
                        style={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "#485450",
                        }}
                      >
                        Conjunto de exclusión
                      </Typography>
                    </Grid>
                    <Grid item xs={4} style={{ paddingTop: 3 }}>
                      <Typography
                        style={{
                          fontSize: 14,

                          fontWeight: "bold",
                          color: "#485450",
                        }}
                      >
                        Suborganización:
                      </Typography>
                    </Grid>
                    <Grid item xs={8} style={{ paddingTop: 3 }}>
                      <Typography
                        style={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "#6e7a76",
                        }}
                      >
                        {item.destinationExclusions.suborganizationGroups[0]}
                      </Typography>
                    </Grid>
                  </>
                )}
            </Grid>
          </Grid>
        ))}
    </div>
  )
}
